module.exports = __webpack_public_path__ + "static/media/left-arrow.20e1c923.svg";